<template>
	<s-modal-bottom-sheet
		v-model="show"
	>
		<template #activator="{ on }">
			<v-btn
				outlined
				small
				v-on="on"
			>
				Создать из МойСклад
			</v-btn>
		</template>

		<v-card flat>
			<v-card-text class="mt-4">
				<v-text-field
					v-model="filter.name"
					class="mt-2"
					outlined
					dense
					hide-details
					placeholder="Начните вводить для поиска"
				/>
				<v-list>
					<v-list-item
						v-for="client in clients"
						:key="client.id"
						@click="createClient(client)"
					>
						<v-list-item-title
							v-text="client.name"
						/>
					</v-list-item>
				</v-list>
			</v-card-text>
		</v-card>
	</s-modal-bottom-sheet>
</template>

<script>
import SModalBottomSheet from '@/components/base/s-modal-bottom-sheet';
import axios from 'axios';

export default {
	name: 'CreateClientModal',
	components: { SModalBottomSheet },
	data: () => ({
		show: false,
		loading: false,
		clients: [],
		filter: {
			name: null,
		},
	}),
	watch: {
		show(val) {
			if (!val) return;
			this.fetchClients();
		},
		filter: {
			deep: true,
			handler(newValue) {
				this.fetchClients()
			},
		},
	},
	mounted() {
		this.CancelToken = axios.CancelToken;
		this.source = this.CancelToken.source();
	},
	methods: {
		async fetchClients() {
			this.source.cancel('Operation cancelled by user');
			this.source = this.CancelToken.source();
			this.loading = true;
			try {
				const response = await this.$http.get('/api/v2/clients/moysklad', {
					params: {
						filter: this.filter,
					},
					cancelToken: this.source.token,
				});
				this.clients = response.data.data;
			} catch (e) {
				if (!axios.isCancel(e)) {
					this.$notify.error(e.message);
				}
			} finally {
				this.loading = false;
			}
		},
		async createClient(client) {
			if (this.loading) return;
			this.loading = true;
			try {
				const response = await this.$http.post('/api/v2/clients', {
					name: client.name,
					email: client?.email,
					phone: client?.phone,
					moysklad_id: client.id,
				});
				console.debug('here');
				if (response.status === 200) {
					this.$notify('Клиент уже создан в каталоге');
				} else {
					this.$notify('Клиент создан')
				}
				await this.$router.push(`clients/${response.data.data.id}`);
			} catch (e) {
				if (e?.response?.status === 422) {
					// const message = `Ошибка создания клиента: ` + .join(',  ');
					this.$notify.error(null, {
						slot: [
							this.$createElement('p', [ 'Ошибка создания клиента:' ]),
							this.$createElement('ul',
								Object.values(e.response.data.errors).flat()
									.map(item => this.$createElement('li', [ `${item} в МойСклад` ])),
							),
						],
					})
				} else {
					// this.$notify.error('Ошибка')
				}
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped>

</style>
